// Setup
import * as _redux from './setup'
// React Query
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from './lib/react-query'
// Axios
import axios from 'axios'
import ReactDOM from 'react-dom/client'
// Apps
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/

// import './_metronic/assets/sass/style.scss'
// import './_metronic/assets/sass/style.dark.scss'
import './_metronic/assets/sass/style.react.scss'
import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/customeClass.scss'
import './_metronic/assets/sass/rtl.scss'
import './_metronic/assets/sass/luminousToast.scss'
import './_metronic/assets/sass/luminousConfirm.scss'
import '@xyflow/react/dist/style.css'
// Side-effect import: installs the global ApexCharts defaults (animations off).
// Must run before any chart is constructed, hence at the entry point.
import './app/utils/apexDefaults'
import { AppRoutes } from './app/routing/AppRoutes'
import { LuminousToaster } from './components/LuminousToaster'
import { LuminousConfirmHost } from './components/LuminousConfirm'
import { I18nProvider } from './_metronic/i18n/i18nProvider'


/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */


_redux.setupAxios(axios)
// const isNotification = featureFlagEngine.isFeatureEnabled("header_notifications")
// Chart.register(...registerables)
if ('serviceWorker' in navigator) {
  // if (isNotification) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js', { type: 'module' })
    .then((registration) => {

    })
    .catch((error) => {

    })
  // }

  // Remove the legacy offline PWA service worker for returning users.
  // Only unregister pwa-sw.js — leave firebase-messaging-sw.js intact.
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      const scriptURL =
        registration.active?.scriptURL ||
        registration.waiting?.scriptURL ||
        registration.installing?.scriptURL ||
        ''
      if (scriptURL.includes('pwa-sw.js')) {
        registration.unregister()
      }
    })
  })
}
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <MetronicI18nProvider>
      <I18nProvider>

        <LuminousToaster />
        <LuminousConfirmHost />
        <AppRoutes />
      </I18nProvider>

    </MetronicI18nProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
  // </React.StrictMode>
)

